import styled from 'styled-components'
import { SpecialButton } from '@chegg-wt/core/theme/fanta/button'
import { colors } from '@chegg-ui/theme'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'

export const FreeTrialCTA = styled(SpecialButton)`
  margin: auto 0px auto 24px;
  min-height: 30px;
  height: auto;
  font-size: ${FantaTheme.font.text.size.lg} !important;
  line-height: initial;
`

export const BoldText = styled.div`
  font-size: ${FantaTheme.font.text.size.lg};
  font-weight: ${FantaTheme.font.weight.bold};
`

export const Banner = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.skyLight};
  justify-content: center;
  align-items: center;
  text-align: center;

  width: 100%;
  min-height: '72px';
  padding: ${FantaTheme.spacing.fanta.sm};
  font-size: ${FantaTheme.font.text.size.md};
  line-height: 1.25rem;
  margin: 5px auto;
`
